import { render, staticRenderFns } from "./CredorDividas.vue?vue&type=template&id=3b261406&"
import script from "./CredorDividas.vue?vue&type=script&lang=js&"
export * from "./CredorDividas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports